<template>
    <div>
        <h3 class="mb-0">Other Product Details</h3>
        <b-form role="form" class="mt-4" @submit.prevent="addOtherLoan">
            <b-row>                
                <b-col md="8" cols="12">
                    <b-form-group label="Product">
                        <el-select v-model="form.prod_oth_type" placeholder="Select" allow-create filterable>
                            <el-option
                                v-for="(item, index) in PRODUCT_TYPES"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Product Details">
                        <b-form-input
                            v-model="form.prod_oth_detail"
                            type="text"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12">
                    <b-form-group label="Product Value (RM)">
                        <CurrencyInput
                            v-model="form.prod_oth_value"
                            :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                        />
                    </b-form-group>
                </b-col>
                

                <b-col cols="12" v-if="checkAppCode('sas')">
                    <h3 class="mb-4">Arrangement Fee</h3>
                </b-col>
    
                <b-col md="8" cols="10" v-if="checkAppCode('sas')">
                    <b-form-group label="Arrangement Fee Amount">
                        <b-form-input
                        v-model="form.prod_oth_agreement_rate"
                        type="number"
                        step="0.01"
                            ></b-form-input>
                    </b-form-group>
                </b-col>
                
                <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                    <b-form-group label="Arrangement Fee SST">
                        <b-form-radio-group
                            v-model="form.prod_oth_agreement_rate_sst"
                            :options="SST_OPTIONS"
                        ></b-form-radio-group>
                    </b-form-group>
                </b-col>

                <b-col md="8" cols="12" v-if="checkAppCode('sas')">
                        <b-form-group label="Total Arrangement Fee (RM)">
                        <b-form-input
                        v-model="form.prod_oth_agreement_fees"
                        type="text"
                        required
                        disabled
                        placeholder="0.00"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

                <b-col md="8" cols="12">
                    <b-form-group label="Payment Mode">
                        <el-select v-model="form.prod_oth_pay_mode" placeholder="Select" filterable>
                            <el-option
                                v-for="(item, index) in PAYMENT_MODES"
                                :key="index"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </b-form-group>
                </b-col>

                <b-col md="8" cols="12">
                    <b-button block variant="primary" class="mb-5" type="submit">Add</b-button>
                </b-col>
            </b-row>
        </b-form>
    </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'
import {
notifyFunctionMixin,
helperFunctionMixin
} from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import {PRODUCT_OTHER_LOAN, SST_OPTIONS} from '@/assets/js/options.js'

export default {
    mixins:[
        notifyFunctionMixin,
        helperFunctionMixin
    ],
    components: {
        CurrencyInput,
        [Select.name]: Select,
        [Option.name]: Option,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
    },
    data() {
        return {
            form: {
                prod_oth_type: '',
                prod_oth_detail: '',
                prod_oth_value: 0,
                prod_oth_pay_mode:'',
                prod_oth_agreement_rate: 0,
                prod_oth_agreement_rate_sst: 0,
                prod_oth_agreement_fees: 0
            },
            PRODUCT_TYPES: PRODUCT_OTHER_LOAN.PRODUCT_TYPES,
            PAYMENT_MODES: PRODUCT_OTHER_LOAN.PAYMENT_MODES,
            SST_OPTIONS: SST_OPTIONS,
        }
    },
    watch:{
        'form':{
            handler(newVal){
                if(newVal){ 
                    let sst_fee = parseFloat(this.form.prod_oth_agreement_rate) * parseFloat(this.form.prod_oth_agreement_rate_sst) / 100
                    //set total arragement fee
                    let arrangement_fee_amount = parseFloat(this.form.prod_oth_agreement_rate) + parseFloat(sst_fee)
                    if(isNaN(arrangement_fee_amount)){
                        this.form.prod_oth_agreement_fees = 0
                    }else{
                        this.form.prod_oth_agreement_fees = arrangement_fee_amount
                    }
                }
            },
            deep: true
        }
    },
    methods: {
        ...mapActions(useProductStore, ['createOtherLoanProduct']),
        resetForm(){
                this.form.prod_oth_type = '',
                this.form.prod_oth_detail = '',
                this.form.prod_oth_value = 0,
                this.form.prod_oth_pay_mode ='',
                this.form.prod_oth_agreement_rate = 0,
                this.form.prod_oth_agreement_rate_sst = 0,
                this.form.prod_oth_agreement_fees = 0
        },
        async addOtherLoan(){
            if(this.form.prod_oth_type == ''){
                this.errorFunction(null, 'Product is missing.')
                return
            }

            const other_loan = {
                prod_oth_type: this.form.prod_oth_type,
                prod_oth_detail:this.form.prod_oth_detail,
                prod_oth_value:this.form.prod_oth_value,
                prod_oth_pay_mode:this.form.prod_oth_pay_mode,
                prod_oth_agreement_rate:this.form.prod_oth_agreement_rate,
                prod_oth_agreement_rate_sst:this.form.prod_oth_agreement_rate_sst,
                prod_oth_agreement_fees:this.form.prod_oth_agreement_fees
            }

            useProductStore().$patch((state) => {
                state.current_product_data = { 
                    ...state.current_product_data, 
                    other_loan: other_loan
                }
            })

            try{
                await this.createOtherLoanProduct()
                this.notifySuccess('<b>Draft </b> - Successfully Created.')
                this.resetForm()
                solutionEventBus.$emit('show-otherloan-summary')
            }catch(e){
                this.errorFunction(null, e)
            }
        },
        preventNonNumericInput(event) {
            const keyCode = event.keyCode || event.which;
            const keyValue = String.fromCharCode(keyCode);
            const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
            const allowedKeys = [8, 37, 38, 39, 40, 46];
            if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
                event.preventDefault();
            }
        },
        emitEvent(eventName) {
            solutionEventBus.$emit(eventName)
        },
    }
}
</script>